import { Globals } from "utils/styleconfig";
import { useNavigate } from "react-router-dom";
import { RiArrowLeftSLine } from "react-icons/ri";

import styles from "styles/modules/Error.module.scss";

const Unauthorized = ({ message }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <h1>Oops!</h1>
        <p>401 Unauthorized</p>
        <p>
          <i>{message}</i>
        </p>
        <button onClick={() => navigate(-1)}>
          <RiArrowLeftSLine color={Globals.colorGray} size={18} />
          <span>Go Back</span>
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
